import { Identifiable, Task } from "@planzone/dto";

function sortByNameAscending(
  first: Identifiable<Task>,
  second: Identifiable<Task>,
) {
  return first.name < second.name ? -1 : 1;
}

function sortByNameDescending(
  first: Identifiable<Task>,
  second: Identifiable<Task>,
) {
  return first.name < second.name ? 1 : -1;
}

function sortByStatusAscending(
  first: Identifiable<Task>,
  second: Identifiable<Task>,
) {
  return typeof first.status.percentComplete === "undefined"
    ? -1
    : typeof second.status.percentComplete === "undefined"
      ? 1
      : first.status.percentComplete < second.status.percentComplete
        ? -1
        : 1;
}

function sortByStatusDescending(
  first: Identifiable<Task>,
  second: Identifiable<Task>,
) {
  return typeof first.status.percentComplete === "undefined"
    ? 1
    : typeof second.status.percentComplete === "undefined"
      ? -1
      : first.status.percentComplete < second.status.percentComplete
        ? 1
        : -1;
}

function sortByDateAscending(
  first: Identifiable<Task>,
  second: Identifiable<Task>,
) {
  return new Date(first.endDate) < new Date(second.endDate) ? -1 : 1;
}

function sortByDateDescending(
  first: Identifiable<Task>,
  second: Identifiable<Task>,
) {
  return new Date(first.endDate) < new Date(second.endDate) ? 1 : -1;
}

function sortByDefaultOrder(
  first: Identifiable<Task>,
  second: Identifiable<Task>,
) {
  return 0;
}

export {
  sortByDefaultOrder,
  sortByNameAscending,
  sortByNameDescending,
  sortByStatusAscending,
  sortByStatusDescending,
  sortByDateAscending,
  sortByDateDescending,
};
